var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineFolderConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 21c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75S9.25 22.52 9.25 21zm1.5 0a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM6 21.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75H6z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.75c-3.22 0-4.25-1.03-4.25-4.25v-7c0-3.22 1.03-4.25 4.25-4.25h1.05c1.33 0 1.76.45 2.28 1.14l1.05 1.4c.2.26.2.26.52.26h2.1c3.22 0 4.25 1.03 4.25 4.25v4.2c0 3.22-1.03 4.25-4.25 4.25h-7zM5.75 5.5v7c0 2.39.36 2.75 2.75 2.75h7c2.39 0 2.75-.36 2.75-2.75V8.3c0-2.39-.36-2.75-2.75-2.75h-2.1c-.99 0-1.35-.37-1.71-.85l-1.06-1.41c-.35-.47-.4-.54-1.08-.54H8.5c-2.39 0-2.75.36-2.75 2.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineFolderConnection);
export default __webpack_public_path__ + "static/media/vuesax-outline-folder-connection.44574b27c5275cd88a429aa7764872df.svg";
export { ForwardRef as ReactComponent };